import { render } from "./detalleAsegurado.vue?vue&type=template&id=3819204e"
import script from "./detalleAsegurado.vue?vue&type=script&lang=js"
export * from "./detalleAsegurado.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__